import { z } from 'zod';
export const requiredClearableField = (fieldName, valueSchema) => z
    .unknown()
    .superRefine((value, context) => {
    if (value === undefined) {
        context.addIssue({
            code: 'custom',
            message: `Pass ${fieldName}, or null to clear it.`,
            path: [],
        });
        return;
    }
    const parsed = valueSchema.safeParse(value);
    if (!parsed.success) {
        context.addIssue({ code: 'custom', message: parsed.error.issues[0].message, path: [] });
    }
})
    .transform((value) => value);
//# sourceMappingURL=required-clearable-field.js.map